// extracted by mini-css-extract-plugin
export default {"container":"JoinTeam_container__hQ1hO","centered":"JoinTeam_centered__p9NqG"};